module.exports = __webpack_public_path__ + "img/web-about-vision.aedbe49a.png";